var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "130px",
    height: "240px",
    viewBox: "0 0 130 240",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Drop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "homepage",
    transform: "translate(-655.000000, -3425.000000)",
    fill: "#288BA0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outro",
    transform: "translate(509.000000, 3200.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.9998,431.8275 C193.0588,431.8275 178.5138,417.2825 178.5138,399.3415 C178.5138,381.3985 193.0588,366.8545 210.9998,366.8545 C228.9418,366.8545 243.4858,381.3985 243.4858,399.3415 C243.4858,417.2825 228.9418,431.8275 210.9998,431.8275 M241.4578,341.9175 L241.4688,341.9115 C213.0008,326.2195 213.0008,305.5575 213.0008,295.0245 L213.0008,224.9995 L208.9988,224.9995 L208.9988,295.0245 C208.9988,305.5575 208.9988,326.2195 180.5318,341.9115 L180.5418,341.9175 C159.9968,352.8375 145.9998,374.4505 145.9998,399.3415 C145.9998,435.2395 175.1018,464.3415 210.9998,464.3415 C246.8978,464.3415 275.9998,435.2395 275.9998,399.3415 C275.9998,374.4505 262.0038,352.8375 241.4578,341.9175",
    id: "Drop"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/Drop.7c1a110e12b29d76b26f43e7954e860c.svg";
export { ForwardRef as ReactComponent };